function server() {
    // return 'https://api.liberrex.tn/v1'
    switch (localStorage.getItem('Server')) {
        case 'tn': return process.env.VUE_APP_API_URL_TN;
        case 'ci': return process.env.VUE_APP_API_URL_CI;
        default: return process.env.VUE_APP_API_URL;
    }
}

export const ApiConfigs = {
    base_url: server() + '/manager',
    broadcast_url: server() + '/broadcasting',
    upload_video_url: process.env.VUE_APP_UPLOAD_VIDEO_URL + '/manager',
    captcha_url: process.env.VUE_APP_CAPTCHA_URL,
    /* -------------------------------- */
    // PUSHER
    pusher: {
        auth: '/auth',
    },
    // ACCOUNT
    accounts: {
        login: '/account/auth',
        logout: '/account/logout',
        reset_password: '/account/password/reset',
        reset_update_password: '/account/password/reset/update',
        createaccount: '/account',
        update_password: '/account/password/update'
    },
    services: {
        getAll: '/services',
        getByIndustry: '/services-by-industry'
    },
    //SMS
    sms: {
        getAll: '/sms',
        getPage: '/sms?pagination=10&page=',
        getByDateRange: '/sms/range',
        getByBusiness: '/sms/business/:id',
        getByBusinessByPage: '/sms/business/:id?pagination=10&page='
    },
    //TEAM
    team: {
        addTeamMember: '/team',
        getById: '/team/:id',
        delete: '/team/:id',
        update: '/team/:id',
        getAll: '/team',
        getPage: '/team?pagination=10&page=',
        getByBusiness: '/team/:id',
        getByBusinessByPage: '/team/:id?pagination=10&page='

    },
    // terms & conditions
    terms: {
        getTerms: '/terms',
        addTerms: '/terms/set'
    },
    // policy
    policy: {
        getPolicy: '/policy',
        addPolicy: '/policy/set'
    },
    //Business = Agency
    business: {
        getAll: '/business',
        getPage: '/business?pagination=10&page=',
        getById: '/business/:id',
        deleteBusiness: '/business/:id',
        create: '/business',
        update: '/business/:id',
        filter: '/business/filter',
        changePassword: '/business/changePassword',
        getMembers: '/business/:id/getMembers',
        updateAgenciesWorkingDays: '/business/updateAgenciesWorkingDays',
        updateAgenciesBookingDays: '/business/updateAgenciesBookingDays',
        updateAgenciesKiosks: '/business/updateAgenciesKiosks',
        updateAgenciesDisplays: '/business/updateAgenciesDisplays',
        updateAgenciesDisplaysVideo: '/business/updateAgenciesDisplaysVideo',
        changeModeMaintenanceStatus: '/business/changeModeMaintenanceStatus'
    },
    //display
    displays: {
        getAll: "/display",
        pagination: '/display?page=',
        delete: '/display/:id/delete',
        create: '/display/create',
        update: '/display/:id/update',
        updateVideo: '/display/:id/video-update',
    },
    //kiosk
    kiosks: {
        getAll: "/kiosk",
        pagination: '/kiosk?page=',
        delete: '/kiosk/:id/delete',
        create: '/kiosk/create',
        update: '/kiosk/:id/update',
        updateVideo: '/kiosk/:id/video-update',
    },
    //feedback
    feedback: {
        filter: '/feedback/filter',
        getAll: '/feedback',
        getPage: '/feedback?pagination=10&page=',
        getPageFilter: '/feedback/filter?page=',
        getById: '/feedback/:id',
        deleteFeedback: '/feedback/:id',
        getByBusiness: '/feedback/filter',
        getByBusinessByPage: '/feedback/filter?pagination=10&page='
    },
    // HELPERS
    helpers: {
        getAdsllServices: '/helpers/service?pagination=1000',
        filterServices: '/helpers/setting/filter/:keyword',
        getIndustries: '/industry',
        getCountries: '/countries'
    },
    //customer
    customer: {
        getAll: '/customer',
        getPage: '/customer?pagination=10&page=',
        getById: '/customer/:id',
        delete: '/customer/:id',
        update: '/customer/:id',
        create: '/customer/create',
        filter: '/customer/filter'
    },
    customer_book: {
        getAll: '/customer/book/:book_id?pagination=off',
        pagination: '/customer/book/:book_id?page=',
        add: '/customer/book/:book_id/add/:customer_id',
        remove: '/customer/book/:book_id/remove/:customer_id',
    },
    //Organization 
    organization: {
        get: '/organization',
        update: '/organization/:id',
        getTicketSettings: '/ticketSettings',
        updateTicketSettings: '/ticketSettings'
    },
    statistics: {
        getAll: '/statistic',
        filter: '/statistic/filter',
        home: '/statistic/home',
        home_filter: '/statistic/home/filter',
        avgWatingService: '/statistic/AvgWatingService',
        visitFrequency: '/statistic/visiteFrequency',
        queueVisitFrequency: '/statistic/queueVisitFrequency',
        bookingVisitFrequency: '/statistic/bookingVisitFrequency',
        serviceFrequency: '/statistic/servicefrequency',
        serviceDurationsPerCounter: '/statistic/serviceDurationsPerCounter',
        serviceDurations: '/statistic/serviceDurations',
        customerStat: '/statistic/customerStat',
        bookingPaymentStat: '/statistic/bookingPaymentStat',
        totalSms: '/statistic/sum-sms-transactions',
        totalTickets: '/statistic/sum-queue',
        totalServices: '/statistic/sum-services',
        totalBookings: '/statistic/sum-bookings',
        avgWaitingTime: '/statistic/avg-waiting-time',
        avgServiceTime: '/statistic/avg-service-time',
        hourPeak: '/statistic/queue-frequency-per-hour',
        counterPerformance: '/statistic/counter-performance',
        bookingPaymentAllTransactions: '/statistic/bookingPaymentAllTransactions',
        counterServiceDuration: '/statistic/counter-service-durations',
        counterFeedbackStatistics: '/statistic/counter-feedbacks-with-services',
        feedbackStatistics: '/statistic/feedbacks-with-services'
    },
    //Account = Organization Team
    account: {
        getAll: '/account',
        getById: '/account/:id',
        getPage: '/account?pagination=10&page=',
        create: '/account',
        delete: '/account/:id',
        update: '/account/:id'
    },
    //investigations
    investigations: {
        getAll: '/investigation',
        createInvestigation: '/investigation/create',
        createQuestion: '/investigation/question/create',
        update: '/investigation/update',
        updateStatus: '/investigation/:id/update',
        updateQuestion: '/investigation/question/:id/update',
        createAnswer: '/answer/create',
        updateAnswer: '/answer/:id/update',
        deleteQuestion: '/investigation/question/:id/delete',
        deleteAnswer: '/answer/:id/delete',
    },
    /* -------------------------------- */
    // QUEUES
    queues: {
        // QUEUE RELATED
        getQueuesByBusinessId: '/business/:id/queues',
        getAll: '/queue?pagination=off',
        getAllWithSummary: '/queue/summary?pagination=off',
        getForService: '/queue/getforservice',
        get: '/queue/:id',
        getWithSummary: '/queue/:id/summary',
        pagination: '/queue?page=',
        paginationWithSummary: '/queue/summary?page=',
        create: '/queue/create',
        update: '/queue/:id/update',
        _delete: '/queue/:id/delete',
        getInService: '/queue/:id/inservice',
        getWaitingList: '/queue/:id/waitinglist',
        getArchivedWaitingList: '/queue/:id/archive',
        retrieveArchivedTicket: '/queue/archive/:id/restore',
        // TICKET RELATED
        push: '/queue/:id/push',
        revoke: '/queue/:queue_id/revoke/:customer_id',
        swap: '/queue/:queue_id/swap/:customer_1/:customer_2',
        move: '/queue/:queue_id/move/:ticket_id/:old/:new',
        pushBack: '/queue/:queue_id/pushback/:ticket_id',
        updateMember: '/queue/:queue_id/member/update/:customer_id',
        noshow: '/queue/:queue_id/noshow/:customer_id',
        updateUrgentStatus: '/queue/:queue_id/urgent/:ticket_id',
        addNote: '/queue/:queue_id/ticket/:ticket_id/notes',
        redirect: '/queue/:queue_id/redirect/:customer_id/:target_id',
        callNext: '/queue/:queue_id/call',
        getTicketByUid: '/queue/uid/:uid',
        getArchivedTicketByUid: '/queue/archive/uid/:uid',
        submitFeedbackByUid: '/queue/uid/:uid/feedback',
        cancelByUid: '/queue/uid/:uid/cancel',
        update_translations: '/queue/:id/translations/update',
        get_translations: '/queue/:id/translations',
        getQueueSlots: '/queue/:id/slot',
        updateQueueSlots: '/queue/:id/slot',
        updateDuration: '/queue/:queue_id/ticket/:ticket_id/duration',
        // DELAY RELATED
        createDelay: '/queue/:id/delay',
        pause: '/queue/:id/pause',
        resumeService: '/queue/:id/resume',

        fixDamagedTickets: '/queue/ticket/:id/fixDamagedTickets',
        fixAllDamagedTickets: '/queue/fixAllDamagedTickets',
        getDamagedtickets: '/queue/getDamagedtickets'
    },
    region: {
        getAllCountriesWithStates: '/zones'
    }
};
